var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crly-m-common-search-keyword-category"},[_vm._l((_vm.CONST.CATEGORY_TYPE),function(cat,index){return [_c('CrlyAtomsCommonSearchKeywordCategoryBtn',{key:index,attrs:{"category":cat,"active":_vm.activeCat},on:{"clickCatBtn":_vm.clickCatBtn}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }